import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { CultureInsertService } from '../../service/culture-insert/culture-insert.service';

@Component({
	selector: 'app-culture-insert',
	templateUrl: './culture-insert.component.html',
	providers: [
		CultureInsertService,
		HttpModule
	]
})
export class CultureInsertComponent implements OnInit {

	private token;
	public permissoes: any[] = [];
	culture: FormGroup;
	Descricao: string = "";
	UnidadeMedida: string = "";
	statusCulture: boolean;

	constructor(fb: FormBuilder, private cultureInsertService: CultureInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.culture = fb.group({
			'Descricao': [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
			'UnidadeMedida':[null, Validators.compose([Validators.required, Validators.maxLength(10)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addCulture(value: any) {
		console.log(value);
		this.cultureInsertService.insertCulture(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Cultura cadastrada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/cultura');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/cultura');
	}

}



// WEBPACK FOOTER //
// ./src/app/culture/component/culture-insert/culture-insert.component.ts